var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "maps", style: { height: _vm.viewHeight + "px" } },
    [
      _c("resize-observer", {
        on: {
          notify: function($event) {
            return _vm.setViewHeight()
          }
        }
      }),
      _vm._v(" "),
      _vm.simpleSearchIsVisible
        ? _c("simple-place-search", {
            attrs: { height: _vm.simpleMapSearchHeight }
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.refreshSearchAvailable
        ? _c(
            "v-btn",
            {
              staticClass: "refresh-search-btn",
              style: { top: _vm.mapHeight - 50 + "px !important" },
              attrs: {
                round: "",
                title: _vm.$t("maps.updateSearchAfterZoomOrCenterChange")
              },
              on: {
                click: function($event) {
                  return _vm.refreshSearch()
                }
              }
            },
            [_vm._v(" " + _vm._s(_vm.$t("maps.updateSearch")) + "\n  ")]
          )
        : _vm._e(),
      _vm._v(" "),
      _c("map-view", {
        ref: "mapView",
        attrs: {
          "initial-zoom": _vm.zoom,
          "avoid-polygons": _vm.avoidPolygons,
          "map-view-data": _vm.mapViewData,
          center: _vm.mapViewCenter,
          "show-popups": _vm.showMapViewClickPopups,
          height: _vm.mapHeight,
          "fit-bounds": _vm.fitMapBounds,
          "custom-tile-provider-url":
            _vm.$store.getters.mapSettings.customTileProviderUrl,
          shrunk: _vm.$store.getters.leftSideBarOpen,
          "show-controls": _vm.showMapControls,
          mode: _vm.$store.getters.mode,
          "supports-drawing-tool": _vm.supportsDrawingTool,
          "routing-profile-icon": _vm.currentProfileIcon
        },
        on: {
          mapReady: _vm.mapReady,
          onCreate: _vm.orsMapCreated,
          markerDragged: _vm.markerDragged,
          directionsFromPoint: _vm.directionsFromPoint,
          directionsToPoint: _vm.directionsToPoint,
          addRouteStop: _vm.addRouteStop,
          addDestinationToRoute: _vm.addDestinationToRoute,
          avoidPolygonsChanged: _vm.avoidPolygonsChanged,
          zoomChanged: _vm.zoomChanged,
          mapCenterMoved: _vm.mapCenterMoved,
          addAsIsochroneCenter: _vm.addAsIsochroneCenter,
          removePlace: _vm.removePlace,
          directChanged: _vm.directChanged,
          mapCenterChanged: _vm.mapCenterChanged,
          setInputPlace: _vm.setInputPlace,
          markerClicked: _vm.markerClicked
        }
      }),
      _vm._v(" "),
      _vm.showBottomNav && !_vm.$store.getters.embed
        ? _c(
            "v-bottom-nav",
            {
              staticClass: "places-nav",
              style: {
                height: _vm.bottomNavHeight + "px !important",
                top: _vm.bottomNavTop + "px !important"
              },
              attrs: { absolute: "", color: "white" }
            },
            [
              _c("places-carousel", {
                attrs: {
                  "active-index": _vm.activePlaceIndex,
                  "map-view-data": _vm.mapViewData
                },
                on: {
                  close: _vm.closedBottomNav,
                  placeSelected: _vm.placeIndexSelectedInBottomNav,
                  gotToPlace: _vm.gotToPlace,
                  directionsToPoint: _vm.directionsToPoint
                }
              })
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600", persistent: true, attach: "body" },
          model: {
            value: _vm.isSettingsOpen,
            callback: function($$v) {
              _vm.isSettingsOpen = $$v
            },
            expression: "isSettingsOpen"
          }
        },
        [
          _vm.isSettingsOpen
            ? _c(
                "box",
                {
                  staticClass: "settings-modal",
                  attrs: { background: "white", resizable: "", closable: "" },
                  on: {
                    closed: function($event) {
                      return _vm.closeSettingsModal()
                    }
                  }
                },
                [
                  _c("h3", { attrs: { slot: "header" }, slot: "header" }, [
                    _vm._v(_vm._s(_vm.$t("maps.settings")))
                  ]),
                  _vm._v(" "),
                  _c("settings", { on: { saved: _vm.closeSettingsModal } })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: { "max-width": "600", persistent: true, attach: "body" },
          model: {
            value: _vm.isAboutOpen,
            callback: function($$v) {
              _vm.isAboutOpen = $$v
            },
            expression: "isAboutOpen"
          }
        },
        [
          _vm.isAboutOpen
            ? _c(
                "box",
                {
                  staticClass: "about-modal",
                  attrs: { background: "white", resizable: "", closable: "" },
                  on: {
                    closed: function($event) {
                      return _vm.closeAboutModal()
                    }
                  }
                },
                [
                  _c("h3", { attrs: { slot: "header" }, slot: "header" }, [
                    _vm._v(_vm._s(_vm.$t("maps.aboutTitle")))
                  ]),
                  _vm._v(" "),
                  _c("about")
                ],
                1
              )
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-e6d70c4a", { render: render, staticRenderFns: staticRenderFns })
  }
}